import React, { Component } from "react";
import clsx from "clsx";
import FormWidget from "./FormWidget";
import { ISitePage } from "../../laco-common/base/models/page";
import { UICMSContent } from "../ui/UICMSContent";
import { WidgetType } from "../../laco-common/base/models/widget";

class FormSiteContentPage extends Component<{ page: ISitePage; widgetNo: number; widgetType: WidgetType }, any> {
	render() {
		return (
			<div className={clsx(this.props.widgetType === "form-content-page2" && "bg-gray1")}>
				<div
					className={clsx(
						"container form-site-content section-padding d-flex flex-column flex-xl-row justify-content-xl-start"
					)}
				>
					{!!this.props.page?.formIconUrl && (
						<img className="form-icon order-1 order-xl-0" src={this.props.page.formIconUrl} />
					)}
					{this.props.widgetType === "form-content-page2" ? (
						this.props.page?.content2 ? (
							<UICMSContent className="order-3 order-xl-1" content={this.props.page?.content2} />
						) : null
					) : (
						!!this.props.page?.content && (
							<UICMSContent className="order-3 order-xl-1" content={this.props.page?.content} />
						)
					)}
					<FormWidget
						// className={clsx(this.props.page?.content && "ml-4-desktop")}
						className="order-0 order-xl-2 flex-grow-1"
						formId={
							Array.isArray(this.props.page?.formId)
								? this.props.page?.formId[this.props.widgetNo]
								: this.props.page?.formId
						}
						isNested={true}
						{...this.props}
					/>
				</div>
			</div>
		);
	}
}

export default FormSiteContentPage;
